var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 20C36.6666 10.7952 29.2046 3.33331 19.9999 3.33331C10.7952 3.33331 3.33325 10.7952 3.33325 20C3.33325 29.2047 10.7952 36.6667 19.9999 36.6667C29.2046 36.6667 36.6666 29.2047 36.6666 20Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 20C36.6666 10.7952 29.2046 3.33331 19.9999 3.33331C10.7952 3.33331 3.33325 10.7952 3.33325 20C3.33325 29.2047 10.7952 36.6667 19.9999 36.6667C29.2046 36.6667 36.6666 29.2047 36.6666 20Z",
    fill: "#2C8C53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14V26M26 20H14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.4ccc56e482c17410371a876dd4c036b0.svg";
export { ForwardRef as ReactComponent };